// extracted by mini-css-extract-plugin
export default {"email_card_wrapper":"emailChangeCard_email_card_wrapper__z1QY8","heading":"emailChangeCard_heading__oZmjy"};